<template>
    <div class="invest">
        <div class="box_1 flex-col">
          <div class="p_img">
            <a href="javascript:;">
              <img src="@/assets/client/banner_7.jpg" alt="投资者关系" title="投资者关系">
            </a>
          </div>
          <div class="p_info">
            <div>
              <h2 class="text-white p_btitle">投资者关系</h2>
              <h6 class="text-white p_subtitle">SAILHERO&nbsp;ENVIRONMENTAL&nbsp;PROTECTION</h6>
            </div>
          </div>
          </div>
        <div class="box_3 flex-col">
            <div class="section_2 flex-row">
              <div class="text-wrapper_1 flex-col justify-between">
                <span class="text_13">当前位置：首页&nbsp;&gt;&nbsp;投资者关系</span>
                <span class="text_14">{{modelitemName}}</span>
              </div>
              <div class="box_4 flex-row justify-between">
                <div class="text-wrapper_2 flex-col" @click="setState('IT01')" :style="{'background-color':form.modelitem=='IT01'?'rgba(0, 90, 214, 1)':'white'}">
                  <span class="text_15" :style="{'color':form.modelitem=='IT01'?'white':'rgba(0, 90, 214, 1)'}">公告信息</span>
                </div>
                <div class="text-wrapper_3 flex-col" @click="setState('IT02')" :style="{'background-color':form.modelitem=='IT02'?'rgba(0, 90, 214, 1)':'white'}">
                  <span class="text_16" :style="{'color':form.modelitem=='IT02'?'white':'rgba(0, 90, 214, 1)'}">投资者教育</span>
                </div>
                <div class="text-wrapper_4 flex-col" :style="{'background-color':form.modelitem=='IT03'?'rgba(0, 90, 214, 1)':'white'}">
                  <a class="text_17" href="https://irm.cninfo.com.cn/ircs/company/companyDetail?stockcode=300137&orgId=9900014612" target="_blank" :style="{'color':form.modelitem=='IT03'?'white':'rgba(0, 90, 214, 1)'}">投资者服务</a>
                </div>
                <div class="text-wrapper_5 flex-col" @click="setState('IT04')"  :style="{'background-color':form.modelitem=='IT04'?'rgba(0, 90, 214, 1)':'white'}">
                  <span class="text_18" :style="{'color':form.modelitem=='IT04'?'white':'rgba(0, 90, 214, 1)'}">股票信息</span>
                </div>
              </div>
              <div class="text-wrapper_6_be">
                <transition name="slide">
                  <div class="text-wrapper_6 flex-col" v-if="telshow">
                    <span class="text_19">4001-300-137</span>
                  </div>
                </transition>
              </div>
              <div class="box_8_1">
                <div class="box_5 flex-row" style="cursor:pointer" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                  <div class="image-text_1 flex-col justify-between">
                    <img
                      class="label_1"
                      referrerpolicy="no-referrer"
                      src="@/assets/client/tel.png"
                    />
                    <span class="text-group_1">业务咨询</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="image-wrapper_1 flex-row">
              <img
                class="image_2"
                referrerpolicy="no-referrer"
                src="@/assets/client/xwzxbg.png"
              />
            </div>
            <template  v-if="form.modelitem=='IT01'||form.modelitem=='IT02'">
              <template v-for="(item,index) in loopData0">
                <div class="section_3 flex-row">
                  <div class="box_6 flex-col" @click="selelctNews(item)">
                    <div class="text-wrapper_7 flex-row justify-between">
                      <span class="text_20">{{item.publishdate.substring(0,7)}}</span>
                      <span class="text_21"
                        >{{item.title}}</span
                      >
                    </div>
                    <div class="group_1 flex-row justify-between">
                      <div class="group_2 flex-col justify-between">
                        <span class="text_22">{{item.dd.length==2?item.dd:0+item.dd}}</span>
                        <div class="box_7 flex-col"></div>
                      </div>
                      <span class="paragraph_1"
                        >{{item.subtitle.length>127?item.subtitle.substring(0,127)+"...":item.subtitle}}</span
                      >
                    </div>
                  </div>
                </div>
              </template>
              <div class="section_14 flex-row">
                <div class="group_9 flex-col"></div>
              </div>
              <div class="box_18 flex-row">
                <el-pagination ref="mypage" @current-change="handleCurrentChange" :page-sizes="[12]" :page-size="form.pageSize"
                    :current-page="form.pageIndex" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
              </div>
            </template>
            <template v-if="form.modelitem=='IT04'">
              <div class="stock_div">
                <div class="stock_left">
                  <div class="tit">
                    先河环保
                  </div>
                  <div class="real_num">
                      <span id="last_px" class="real_num">{{stockInfo.last_px}}</span>
                      <div class="shang" :class="stockInfo.zoushiclass" id="rate">{{stockInfo.rate}}</div>
                  </div>
                  <div class="stock_re">截至 <span id="upDate">{{stockInfo.upDate}}</span> 北京时间 *报价有十五分钟或以上延迟。<br/> 资料来源： 新浪财经</div>
                </div>
                <div class="stock_right justify-between">
                    <div>
                        <div class="title">最高</div>
                        <div class="content" id="high_px">{{stockInfo.high_px}}</div>
                    </div>
                    <div>
                      <div class="title">最低</div>
                      <div class="content" id="low_px">{{stockInfo.low_px}}</div>
                    </div>
                    <div>
                      <div class="title">成交量(万手)</div>
                      <div class="content" id="business_amount">{{stockInfo.business_amount}}</div>
                    </div>
                    <div>
                        <div class="title">成交额(亿)</div>
                        <div class="content" id="business_balance">{{stockInfo.business_balance}}</div>
                    </div>
                </div>
              </div>
            </template>
          </div>

          <!-- 移动端投资者关系页面 -->
          <div class="mobile-investor-container">
            <!-- Banner图 -->
            <div class="mobile-investor-banner">
              <img 
                src="@/assets/client/banner_7.jpg" 
                alt="投资者关系" 
                class="mobile-investor-banner__image"
              />
              <div class="mobile-investor-banner__overlay"></div>
              <div class="mobile-investor-banner__content">
                <h1 class="mobile-investor-banner__title">投资者关系</h1>
                <p class="mobile-investor-banner__subtitle">INVESTOR RELATIONS</p>
              </div>
            </div>

            <!-- 当前位置 -->
            <div class="mobile-investor-breadcrumb">
              <p class="mobile-investor-breadcrumb__text">
                当前位置：首页 > 投资者关系 > 
                <span class="mobile-investor-breadcrumb__current">{{ modelitemName }}</span>
              </p>
            </div>

            <!-- 子菜单按钮列表 -->
            <div class="mobile-investor-submenu">
              <div class="mobile-investor-submenu__grid">
                <button
                  :class="['mobile-investor-submenu__button', { 'mobile-investor-submenu__button--active': form.modelitem === 'IT01' }]"
                  @click="setState('IT01')"
                >
                  公告信息
                </button>
                <button
                  :class="['mobile-investor-submenu__button', { 'mobile-investor-submenu__button--active': form.modelitem === 'IT02' }]"
                  @click="setState('IT02')"
                >
                  投资者教育
                </button>
                <button
                  class="mobile-investor-submenu__button"
                  @click="openInvestorService"
                >
                  投资者服务
                </button>
                <button
                  :class="['mobile-investor-submenu__button', { 'mobile-investor-submenu__button--active': form.modelitem === 'IT04' }]"
                  @click="setState('IT04')"
                >
                  股票信息
                </button>
              </div>
            </div>

            <!-- 列表区域（公告信息和投资者教育）-->
            <div v-if="form.modelitem === 'IT01' || form.modelitem === 'IT02'" class="mobile-investor-list">
              <h2 class="mobile-investor-list__title">{{ modelitemName }}</h2>
              
              <div v-if="loopData0.length > 0">
                <div
                  v-for="(item, index) in getMobileDisplayData()"
                  :key="item.id"
                  class="mobile-investor-card"
                  @click="selelctNews(item)"
                >
                  <div class="mobile-investor-card__header">
                    <span class="mobile-investor-card__date">{{ item.publishdate.substring(0, 7) }}</span>
                    <span class="mobile-investor-card__day">{{ item.dd.length == 2 ? item.dd : '0' + item.dd }}</span>
                  </div>
                  <div class="mobile-investor-card__content">
                    <h3 class="mobile-investor-card__title">{{ item.title }}</h3>
                    <p class="mobile-investor-card__subtitle">{{ item.subtitle.length > 80 ? item.subtitle.substring(0, 80) + '...' : item.subtitle }}</p>
                  </div>
                  <div class="mobile-investor-card__footer">
                    <span class="mobile-investor-card__more">
                      <span>查看详情</span>
                      <span class="mobile-investor-card__more-icon el-icon-arrow-right"></span>
                    </span>
                  </div>
                </div>
              </div>

              <!-- 空状态 -->
              <div v-else class="mobile-investor-empty">
                <div class="mobile-investor-empty__icon">📄</div>
                <p class="mobile-investor-empty__text">暂无数据</p>
              </div>
            </div>

            <!-- 股票信息区域 -->
            <div v-if="form.modelitem === 'IT04'" class="mobile-investor-stock">
              <div class="mobile-investor-stock__header">
                <h2 class="mobile-investor-stock__title">先河环保</h2>
                <div class="mobile-investor-stock__price">
                  <span class="mobile-investor-stock__value">{{ stockInfo.last_px }}</span>
                  <span :class="['mobile-investor-stock__change', stockInfo.zoushiclass]">{{ stockInfo.rate }}</span>
                </div>
                <p class="mobile-investor-stock__note">
                  截至 {{ stockInfo.upDate }} 北京时间<br/>
                  *报价有十五分钟或以上延迟。资料来源：新浪财经
                </p>
              </div>
              <div class="mobile-investor-stock__grid">
                <div class="mobile-investor-stock__item">
                  <div class="mobile-investor-stock__label">最高</div>
                  <div class="mobile-investor-stock__data">{{ stockInfo.high_px }}</div>
                </div>
                <div class="mobile-investor-stock__item">
                  <div class="mobile-investor-stock__label">最低</div>
                  <div class="mobile-investor-stock__data">{{ stockInfo.low_px }}</div>
                </div>
                <div class="mobile-investor-stock__item">
                  <div class="mobile-investor-stock__label">成交量(万手)</div>
                  <div class="mobile-investor-stock__data">{{ stockInfo.business_amount }}</div>
                </div>
                <div class="mobile-investor-stock__item">
                  <div class="mobile-investor-stock__label">成交额(亿)</div>
                  <div class="mobile-investor-stock__data">{{ stockInfo.business_balance }}</div>
                </div>
              </div>
            </div>

            <!-- 查看更多按钮（仅公告信息和投资者教育显示）-->
            <div 
              v-if="(form.modelitem === 'IT01' || form.modelitem === 'IT02') && hasMoreData()" 
              class="mobile-investor-loadmore"
            >
              <button 
                class="mobile-investor-loadmore__button"
                @click="loadMoreMobile"
              >
                <span>查看更多</span>
                <span class="mobile-investor-loadmore__icon el-icon-arrow-down"></span>
              </button>
            </div>
          </div>
    </div>
</template>
<script>
  import axios from "axios";
    export default{
        data(){
            return{
              form:{
                pageSize: 6,
                pageIndex: 1,
                modelitem:"IT01",
                newsmodel:"InvestType"
            },
            modelitemName:"公告信息",
            total:0,
            loading:false,
            loopData0:[],
            FileAddress:"",
            interval:null,
            telshow:false,
            bannerClass:'',
            text_11_ami:'',
            stockInfo:{
              business_amount:'',
              business_balance:'',
              high_px:'',
              last_px:'',
              low_px:'',
              upDate:'',
              rate:'',
              zoushiclass:''

            },
            // 移动端相关数据
            isMobile: false,
            mobileDisplayCount: 6,
            mobileInitialCount: 6,
            mobileCurrentPage: 1, // 移动端当前页码
            isLoadingMore: false, // 防止重复请求
            }
        },
        methods:{
          handleCurrentChange(val) {
                let that = this;
                that.form.pageIndex = val;
                that.getNewsCenterlist();
        },
          setState(state){
            let that = this;
            that.form.modelitem = state;
            if(state=="IT01"){
              that.modelitemName = "公告信息";
            }
            if(state=="IT02"){
              that.modelitemName = "投资者教育";
            }
            if(state=="IT03"){
              that.modelitemName = "投资者服务";
            }
            if(state=="IT04"){
              that.modelitemName = "股票信息";
              that.setStock();
            }
            // 重置移动端显示数量和页码
            that.mobileDisplayCount = that.mobileInitialCount;
            that.mobileCurrentPage = 1;
            that.form.pageIndex = 1;
            that.getNewsCenterlist();
          },
          getNewsCenterlist(){
            let that = this;
            // 移动端时增加pageSize以获取更多数据，前端控制显示数量
            let requestForm = { ...that.form };
            if (that.isMobile) {
              requestForm.pageSize = 50; // 移动端一次获取50条，前端分批显示
            }
            
            that.$api.post("/Client/getNewsCenterlist", requestForm,
                function (res) {
                    if (res.code === "200") {
                      that.loopData0 =[];
                      res.data.forEach(item=>{
                        that.loopData0.push({
                            id:item.id,
                            title:item.news_title,
                            subtitle:item.news_subtitle,
                            publishdate:item.publishdate,
                            dd:item.dd,
                            is_open_attachment:item.is_open_attachment,
                            url:item.url,
                            is_open_url:item.is_open_url,
                            FilePath:(process.env.VUE_APP_FileAddress.replace('fileapi/', '') + item.FilePath.replace(" ", "%20").replace(/\\/g, '/')),
                          });
                      });
                        that.total = res.count;
                        that.loading = false;
                    }
                },
                function (res) {
                    that.$message.error("服务异常，信息出错");
                }
            );
          },
          selelctNews(item){
            var _this = this;
              if(item.is_open_attachment=='1'){
                 window.open(item.FilePath, '_blank');
              }
              else if(item.is_open_url=='1')
              {
                window.open(item.url, '_blank');
              }
              else{
                _this.$router.push({
                    path: "/Client/InvestorRelationsDetails",
                    query: {
                    id:item.id,
                    modelitem:this.form.modelitem,
                    newsmodel:this.form.newsmodel
                },
              });
              }
          },
          toLink(path) {
                this.$router.push(path);
          },
          setStock()
          {
            axios.get('https://hqapi.p5w.net/real?code=300137')
            .then(response => {
              let res = response.data;
              let that = this;
                    var shares_per_hand = res.shares_per_hand
                    var business_amount = (res.business_amount / shares_per_hand / 10000).toFixed(3)
                    var business_balance = (res.business_balance / 10000 / 10000).toFixed(3)
                    var high_px = res.high_px
                    var last_px = res.last_px
                    var low_px = res.low_px
                    var px_change = res.px_change
                    var bid_grp = res.bid_grp;
                    var time = String(res.data_timestamp)
                    var date = String(res.date)
                    if (time.length == 9) {
                        time = time.substr(0, 2) + ':' + time.substr(2, 2) + ':' + time.substr(4, 2)
                    } else {
                        time = time.substr(0, 1) + ':' + time.substr(1, 2) + ':' + time.substr(3, 2)
                    }
                    var upDate = date.substr(0, 4) + '-' + date.substr(4, 2) + '-' + date.substr(6, 2) + ' ' + time
                    that.stockInfo.business_amount = business_amount;
                    that.stockInfo.business_balance =business_balance;
                    that.stockInfo.high_px = high_px;
                    that.stockInfo.last_px = last_px;
                    that.stockInfo.low_px = low_px;
                    that.stockInfo.upDate = upDate;
                    that.stockInfo.rate = res.px_change + '(' + res.px_change_rate + '%)';
                    if (px_change > 0) {
                        that.stockInfo.zoushiclass = 'red';
                    } else if (px_change < 0) {
                      that.stockInfo.zoushiclass = 'green';
                    } else {
                      that.stockInfo.zoushiclass='';
                    }
            })
            .catch(error => {
              this.error = error.message;
            });


            // $.ajax({
            //     url: 'https://hqapi.p5w.net/real?code=300137',
            //     success: function (res) {
            //       let that = this;
            //         var shares_per_hand = res.shares_per_hand
            //         var business_amount = (res.business_amount / shares_per_hand / 10000).toFixed(3)
            //         var business_balance = (res.business_balance / 10000 / 10000).toFixed(3)
            //         var high_px = res.high_px
            //         var last_px = res.last_px
            //         var low_px = res.low_px
            //         var px_change = res.px_change
            //         var bid_grp = res.bid_grp;
            //         var time = String(res.data_timestamp)
            //         var date = String(res.date)
            //         if (time.length == 9) {
            //             time = time.substr(0, 2) + ':' + time.substr(2, 2) + ':' + time.substr(4, 2)
            //         } else {
            //             time = time.substr(0, 1) + ':' + time.substr(1, 2) + ':' + time.substr(3, 2)
            //         }
            //         var upDate = date.substr(0, 4) + '-' + date.substr(4, 2) + '-' + date.substr(6, 2) + ' ' + time
            //         that.stockInfo.business_amount = business_amount;
            //         that.stockInfo.business_balance =business_balance;
            //         that.stockInfo.high_px = high_px;
            //         that.stockInfo.last_px = last_px;
            //         that.stockInfo.low_px = low_px;
            //         that.stockInfo.upDate = upDate;
            //         that.stockInfo.rate = res.px_change + '(' + res.px_change_rate + '%)';
            //         if (px_change > 0) {
            //             that.stockInfo.zoushiclass = 'red';
            //         } else if (px_change < 0) {
            //           that.stockInfo.zoushiclass = 'green';
            //         } else {
            //           that.stockInfo.zoushiclass='';
            //         }
            //     }
            // })
          },
        handleMouseEnter(){
                let that = this;
                that.telshow = true;
        },
        handleMouseLeave(){
            let that = this;
            that.telshow = false;
        },
        // 移动端相关方法
        checkMobile() {
          this.isMobile = window.innerWidth <= 768;
        },
        loadMoreMobile() {
          // 移动端加载更多数据
          const allLoadedCount = this.loopData0.length; // 已加载的总数据量
          const willDisplayCount = this.mobileDisplayCount + this.mobileInitialCount; // 将要显示的数量
          
          // 如果将要显示的数量超过了已加载的数据，且服务器还有更多数据
          if (willDisplayCount >= allLoadedCount && allLoadedCount < this.total) {
            // 需要从服务器加载更多数据
            this.loadMoreDataFromServer();
          } else {
            // 只增加显示数量（数据已经在本地）
            this.mobileDisplayCount += this.mobileInitialCount;
          }
        },
        loadMoreDataFromServer() {
          // 从服务器加载下一页数据
          if (this.isLoadingMore) {
            return; // 防止重复请求
          }
          
          this.isLoadingMore = true;
          this.mobileCurrentPage += 1;
          
          let that = this;
          let requestForm = {
            pageSize: 50,
            pageIndex: that.mobileCurrentPage,
            modelitem: that.form.modelitem,
            newsmodel: that.form.newsmodel
          };
          
          that.$api.post("/Client/getNewsCenterlist", requestForm,
            function (res) {
              if (res.code === "200") {
                // 将新数据追加到现有数组
                res.data.forEach(item => {
                  that.loopData0.push({
                    id: item.id,
                    title: item.news_title,
                    subtitle: item.news_subtitle,
                    publishdate: item.publishdate,
                    dd: item.dd,
                    is_open_attachment: item.is_open_attachment,
                    url: item.url,
                    is_open_url: item.is_open_url,
                    FilePath: (process.env.VUE_APP_FileAddress.replace('fileapi/', '') + item.FilePath.replace(" ", "%20").replace(/\\/g, '/')),
                  });
                });
                
                // 增加显示数量
                that.mobileDisplayCount += that.mobileInitialCount;
                that.isLoadingMore = false;
              }
            },
            function (res) {
              that.$message.error("加载更多数据失败");
              that.isLoadingMore = false;
            }
          );
        },
        getMobileDisplayData() {
          // 获取移动端应该显示的数据列表
          return this.loopData0.slice(0, this.mobileDisplayCount);
        },
        hasMoreData() {
          // 判断是否还有更多数据（本地已加载 或 服务器还有）
          return this.mobileDisplayCount < this.loopData0.length || this.loopData0.length < this.total;
        },
        openInvestorService() {
          // 打开投资者服务外部链接
          window.open('https://irm.cninfo.com.cn/ircs/company/companyDetail?stockcode=300137&orgId=9900014612', '_blank');
        },
        updateModelitemName(type) {
          // 统一更新 modelitem 名称的方法
          if (type === 'IT01') {
            this.modelitemName = "公告信息";
          } else if (type === 'IT02') {
            this.modelitemName = '投资者教育';
          } else if (type === 'IT03') {
            this.modelitemName = '投资者服务';
          } else if (type === 'IT04') {
            this.modelitemName = '股票信息';
          }
        },
        },
        mounted(){
          let that = this;
          
          // 先进行移动端检测，确保后续逻辑能正确判断
          that.checkMobile();
          window.addEventListener('resize', that.checkMobile);
          
          // 优先检查查询参数（用于移动端子菜单）
          if(this.$route.query.type!=null&&this.$route.query.type!=undefined)
          {
            that.form.modelitem = this.$route.query.type;
            that.updateModelitemName(this.$route.query.type);
          }
          // 然后检查query中的modelitem参数
          else if(this.$route.query.modelitem!=null&&this.$route.query.modelitem!=undefined)
          {
            that.form.modelitem = this.$route.query.modelitem;
            that.updateModelitemName(this.$route.query.modelitem);
          }
          // 再检查路由参数（用于PC端）
          else if(this.$route.params.modelitem!=null&&this.$route.params.modelitem!=undefined)
          {
            that.form.modelitem = this.$route.params.modelitem;
            that.updateModelitemName(this.$route.params.modelitem);
          }
          // 如果都没有，使用默认值 IT01
          else {
            that.form.modelitem = 'IT01';
            that.modelitemName = '公告信息';
          }
          
          if(this.$route.params.newsmodel!=null&&this.$route.params.newsmodel!=undefined)
          {
            that.form.newsmodel = this.$route.params.newsmodel;
          }
          
          that.getNewsCenterlist();
          that.setStock();
          
          // 移动端滚动到页面顶部
          if (that.isMobile) {
            that.$nextTick(() => {
              setTimeout(() => {
                // 滚动到移动端容器的位置
                const mobileContainer = document.querySelector('.mobile-investor-container');
                if (mobileContainer) {
                  mobileContainer.scrollIntoView({ behavior: 'auto', block: 'start' });
                } else {
                  // 备选方案：强制滚动到页面顶部
                  window.scrollTo(0, 0);
                  document.documentElement.scrollTop = 0;
                  document.body.scrollTop = 0;
                }
              }, 200);
            });
          }
        },
        beforeDestroy() {
          // 移除事件监听
          window.removeEventListener('resize', this.checkMobile);
        },
        watch:{
          '$route.query.type': {
            handler: function (newType, oldType) {
              // 监听路由查询参数变化（移动端子菜单切换）
              if (newType) {
                this.form.modelitem = newType;
                this.updateModelitemName(newType);
                // 重置移动端显示数量和页码
                this.mobileDisplayCount = this.mobileInitialCount;
                this.mobileCurrentPage = 1;
                this.form.pageIndex = 1;
                this.getNewsCenterlist();
                
                // 如果是股票信息，更新股票数据
                if (newType === 'IT04') {
                  this.setStock();
                }
                
                // 移动端滚动到页面顶部
                if (this.isMobile) {
                  this.$nextTick(() => {
                    setTimeout(() => {
                      // 滚动到移动端容器的位置
                      const mobileContainer = document.querySelector('.mobile-investor-container');
                      if (mobileContainer) {
                        mobileContainer.scrollIntoView({ behavior: 'auto', block: 'start' });
                      } else {
                        // 备选方案：强制滚动到页面顶部
                        window.scrollTo(0, 0);
                        document.documentElement.scrollTop = 0;
                        document.body.scrollTop = 0;
                      }
                    }, 200);
                  });
                }
              }
            }
          }
        }
    }
</script>
<style scoped>
@import '../../../assets/client/investorrelations.css';
@import '../../../assets/client/investorrelations-mobile.css';
.slide-enter-active, .slide-leave-active {
        transition: transform 0.5s;
    }

    .slide-enter, .slide-leave-to /* .slide-leave-active for <2.1.8 */ {
        transform: translateX(22.53vw);
    }
.p_img img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  animation: bannerimg 2s;
}

.p_info .p_btitle {
  animation: puBanner 1s;
  color: #FFF;
  font-size: 59px;
  font-weight: 900;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.p_info .p_subtitle {
  animation: puBanner 1s;
  color: #FFF;
  font-size: 28px;
  font-weight: 400;
  position: relative;
  bottom: 40px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.p_info {
  width: 100%;
  max-width: 1600px;
  padding: 0 5px;
  position: absolute;
  left: 257px;
  top: 120px;
  z-index: 9;
}

@keyframes puBanner {
  from {
    transform: translateY(200px);
    opacity: 0
  }

  to {
    transform: translateY(0);
    opacity: 1
  }
}

@keyframes bannerimg {
  from {
    transform: scale(1.15)
  }

  to {
    transform: scale(1);
  }
}
</style>
